import { Icon } from '@kinesis/bungle';

const FileIcon = (props) => (
  <Icon {...props} type='custom'>
    <svg viewBox='0 0 1024 1024'>
      <path d='M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z' />
    </svg>
  </Icon>
);

FileIcon.propTypes = {};
FileIcon.defaultProps = {};

export { FileIcon };
